// extracted by mini-css-extract-plugin
module.exports = {"frame":"LoginStep-frame-524b"};